"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineFetchLotWishlistItemStatusCheck = void 0;
var react_1 = require("react");
var useLotWishlistItemStatusCheck_1 = require("./useLotWishlistItemStatusCheck");
var useInlineFetchLotWishlistItemStatusCheck = function (requestOptionsInit) {
    var _a = (0, react_1.useState)({ paramsToSend: undefined, queryOptions: undefined }), networkConf = _a[0], setNetworkConfig = _a[1];
    var returnedQueryObject = (0, useLotWishlistItemStatusCheck_1.useLotWishlistItemStatusCheck)(networkConf.paramsToSend, __assign(__assign({}, networkConf.queryOptions), { enabled: !!networkConf.paramsToSend }), requestOptionsInit);
    var fetchInline = (0, react_1.useCallback)(function (params, options) {
        setNetworkConfig(function (prev) { return (__assign(__assign({}, prev), { paramsToSend: __assign(__assign({}, prev.paramsToSend), params), queryOptions: __assign(__assign({}, prev.queryOptions), options) })); });
    }, []);
    return __assign(__assign({}, returnedQueryObject), { fetchInline: fetchInline });
};
exports.useInlineFetchLotWishlistItemStatusCheck = useInlineFetchLotWishlistItemStatusCheck;
